import { render, staticRenderFns } from "./SourceUrl.vue?vue&type=template&id=223881e0"
import script from "./SourceUrl.vue?vue&type=script&lang=js"
export * from "./SourceUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223881e0')) {
      api.createRecord('223881e0', component.options)
    } else {
      api.reload('223881e0', component.options)
    }
    module.hot.accept("./SourceUrl.vue?vue&type=template&id=223881e0", function () {
      api.rerender('223881e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/example/components/Dropdown/SourceUrl.vue"
export default component.exports